import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./i18n";
import Landing from "./pages/Landing";
import CampaignFlow from "./pages/CampaignFlow";
import Legal from "./pages/Legal";
import StaffApp from "./pages/StaffApp";
import MyLoyalty from "./pages/MyLoyalty";
import Flyer from "./pages/Flyer";
import CertificatePage from "./pages/CertificatePage";
import AdminApp from "./admin/AdminApp";
import StaticSite from "./pages/StaticSite";
import JobApplication from "./pages/JobApplication";
import JobsFlyer from "./pages/JobsFlyer";
import Delivery from "./pages/Delivery";

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StaticSite />} />
          <Route path="/index.html" element={<StaticSite />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/loyalty" element={<Landing />} />
          <Route path="/c/:slug" element={<CampaignFlow />} />
          <Route path="/craft/:slug" element={<CampaignFlow />} />
          <Route path="/my/:code" element={<MyLoyalty />} />
          <Route path="/flyer/:slug" element={<Flyer />} />
          <Route path="/cert/:code" element={<CertificatePage />} />
          <Route path="/legal/:doc" element={<Legal />} />
          <Route path="/staff" element={<StaffApp />} />
          <Route path="/jobs" element={<JobApplication />} />
          <Route path="/jobs-flyer" element={<JobsFlyer />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LangProvider>
  );
}

export default App;
